import Icon, { QuestionOutlined } from "@ant-design/icons";
import { LocationType } from "../../../dto/Settings/LocationTypeDto";
import AirportIcon from "../../../img/v2/svg/locations/airport.svg?react";
import CityIcon from "../../../img/v2/svg/locations/city.svg?react";
import PortIcon from "../../../img/v2/svg/locations/port.svg?react";
import RailwayIcon from "../../../img/v2/svg/locations/railway.svg?react";
import exhaustiveCheck from "../../../utils/exhaustiveCheck";

export function getIconByLocationType(type: LocationType) {
  switch (type) {
    case "AIRPORT":
      return <Icon component={AirportIcon} />;
    case "PORT":
      return <Icon component={PortIcon} />;
    case "CITY":
      return <Icon component={CityIcon} />;
    case "RAILWAY":
      return <Icon component={RailwayIcon} />;
    case "UNKNOWN":
      return <QuestionOutlined />;
    default:
      return exhaustiveCheck(type);
  }
}
